import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchFilterEntity } from '../../domain/entities/BranchFilterEntity'

export class BranchFilterModel extends BranchFilterEntity {
  userId?: string
  serviceId?: number
  brandId?: number
  channelIds?: number[]
  saleManId?: number
  constructor(dataDto: BranchFilterEntity) {
    super()
    mapEntityProperties<BranchFilterModel>(this, dataDto, {
      exclude: ['user', 'service', 'brand', 'channels', 'saleMan'],
      map: {
        userId: dataDto.user?.id,
        serviceId: dataDto.service?.id,
        brandId: dataDto.brand?.id,
        channelIds: dataDto.channels?.map((channel) => channel.id),
        saleManId: dataDto.saleMan?.id
      }
    })
  }
}
